import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { setFilter } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";
import { useDispatch, useSelector } from "react-redux";

const NoShowTypeFilter = () => {
  const { noShowType } = useSelector((state) => state.nonCompliantPatient);
  const dispatch = useDispatch();

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="noShowType-select-label">No-show Type</InputLabel>

        <Select
          labelId="noShowType-select-label"
          id="noShowType-select-helper"
          value={noShowType}
          label="No-show Type"
          onChange={(e) => {
            dispatch(
              setFilter({
                type: "noShowType",
                value: e.target.value,
              })
            );
          }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="late">Late</MenuItem>
          <MenuItem value="disconnected">Disconnected</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default NoShowTypeFilter;
